/* eslint-disable no-underscore-dangle */

'use strict';

const onOptionUpdate = ({ optionsMsrpHash, option: optionUuid }) => {
  const setOptionMsrp = uuid => {
    const msrpLabel = document.querySelector('.source-metadata-label');

    const optionMsrp = optionsMsrpHash[uuid];
    if (!optionMsrp && msrpLabel) {
      msrpLabel.innerHTML = '';
      msrpLabel.style.display = 'none';
      if (msrpLabel._tippy) {
        msrpLabel._tippy.setContent('');
        msrpLabel._tippy.disable();
      }
    } else if (optionMsrp && msrpLabel) {
      const { description, label } = optionMsrp;
      msrpLabel.innerHTML = label;
      msrpLabel.style.display = 'block';
      if (msrpLabel._tippy) {
        msrpLabel._tippy.setContent(description);
        msrpLabel._tippy.enable();
      }
    }
  };

  window.DealEventPipe.on('goodsOptionUpdate', ({ uuid }) => {
    setOptionMsrp(uuid);
  });

  setOptionMsrp(optionUuid);
};

const MSRP = {
  init({ msrp }, done) {
    if (!msrp) {
      return done();
    }

    onOptionUpdate(msrp);

    return done();
  },
};

module.exports = MSRP;
